import { useLocation, useNavigate } from 'react-router-dom';
import { FaDice, FaGamepad, FaHome, FaRunning, FaTrophy } from 'react-icons/fa';

const MobileNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { name: 'IN PLAY', path: '/inplay', icon: FaRunning },
    { name: 'SPORTS', path: '/all-sports/Cricket', icon: FaTrophy },
    { name: 'HOME', path: '/home', icon: FaHome },
    {
      name: 'TEENPATI',
      path: `/casino?provider=${encodeURIComponent('Aura Gaming'.toLowerCase())}`,
      icon: FaDice,
    },
    { name: 'I CASINO', path: '/casino', icon: FaGamepad },
  ];

  const isActiveItem = (item: { name: string; path: string }) => {
    if (item.name === 'HOME') return location.pathname === '/home';
    if (item.name === 'SPORTS') return location.pathname.startsWith('/all-sports');
    if (item.name === 'I CASINO') return location.pathname === '/casino';
    if (item.name === 'TEENPATI') return location.pathname === '/casino' && false;
    return location.pathname === item.path;
  };

  return (
    <div className="md:hidden">
      <div className="fixed bottom-0 left-0 right-0 z-50 border-t border-slate-700 bg-secondary-dark rounded-t-2xl shadow-[0_-6px_18px_rgba(0,0,0,0.25)]">
        <div className="grid grid-cols-5">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const active = isActiveItem(item);

            return (
              <button
                key={item.name}
                type="button"
                onClick={() => navigate(item.path)}
                className={[
                  'flex h-12 flex-col items-center justify-center gap-1  transition-all duration-200',
                  active ? ' bg-primary text-white' : 'border-transparent text-slate-300',
                ].join(' ')}
              >
                <Icon className="text-base sm:text-lg" />
                <span className="text-[9px] font-bold uppercase tracking-wide sm:text-[10px]">
                  {item.name}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default MobileNavbar;
